/**
 * 絞り込みサイドバーの追従の補助（PC・990px〜）
 *
 * サイドバーは CSS でヘッダーの下に固定し、高さは画面に収まるところで切っている（c-rail-listing.css）。
 * 画面より長いときにはみ出す下の項目（「検索」ボタンなど）は、サイドバーの上でスクロールすると出てくる。
 * ページをスクロールしても、サイドバーの中身は動かさない（「絞り込み」の見出しがヘッダーの下にある位置のまま）。
 *
 * ここでやるのは、次の4つ。
 *   1. サイドバーが一覧と一緒に上へ流れ出したら、中身を最後まで送る。下端が途中で切れて見えないようにする。
 *      追従する位置に戻ったら、送る前の位置へ戻す
 *   2. 上へ流れるとき、半透明のヘッダーの下に文字が透けて重ならないよう、ヘッダーの下端より上は見せない
 *   3. 見出し（CAMP / HOME & GARDEN / FORESTRY など）を開いたとき、増えた項目がサイドバーの下にはみ出して
 *      切れて見えるので、開いた見出しの項目が見える位置まで中身を送る（2026-10-14）
 *   4. 追従が始まる前（ページを開いた直後）は、サイドバーの高さを画面に見えている分に合わせる。
 *      下端に固定した「検索」ボタンを、開いた直後から見せるため（2026-10-14）
 */
if (!window.__cFilterSticky) {
  window.__cFilterSticky = true;

  (() => {
    const desktop = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('.c-rail-listing__filter').forEach((aside) => {
      let leaving = false; // 一覧の最後で上へ流れている間
      let saved = 0; // 送る前の位置

      const update = () => {
        if (!desktop.matches) {
          aside.style.clipPath = '';
          aside.style.maxHeight = '';
          leaving = false;
          return;
        }

        // 追従する位置（CSS の --c-filter-top）より上に出た量
        const stickyTop = parseFloat(getComputedStyle(aside).getPropertyValue('--c-filter-top')) || 0;
        const rectTop = aside.getBoundingClientRect().top;
        const over = stickyTop - rectTop;

        // 4. まだ追従していない間（ページを開いた直後など。サイドバーの上端が追従の位置より下にある）は、
        //    高さを「いま画面に見えている分」に合わせる。CSS の高さ（画面 − ヘッダー）のままだと下端が画面の外に出て、
        //    下端に固定した「検索」ボタンが見えない。ノート PC の低い画面（高さ 620〜700）でもボタンが入るよう、
        //    下限は「絞り込み」の見出し＋ボタンが入る 120px
        if (rectTop - stickyTop > 1) {
          aside.style.maxHeight = `${Math.max(Math.round(window.innerHeight - rectTop), 120)}px`;
        } else {
          aside.style.maxHeight = '';
        }

        const max = aside.scrollHeight - aside.clientHeight;

        if (over > 1) {
          if (!leaving) {
            leaving = true;
            saved = aside.scrollTop;
            if (max > 0) aside.scrollTo({ top: max, behavior: 'smooth' });
          }
          aside.style.clipPath = `inset(${Math.round(over)}px 0 0 0)`;
        } else {
          if (leaving) {
            leaving = false;
            aside.scrollTo({ top: saved, behavior: 'smooth' });
          }
          aside.style.clipPath = '';
        }
      };

      // 3. 開いた見出しが下にはみ出したら、見える位置まで送る（閉じたときは何もしない）
      const reveal = (group) => {
        if (!desktop.matches || !group.hasAttribute('open')) return;
        if (aside.scrollHeight - aside.clientHeight <= 0) return;

        const asideRect = aside.getBoundingClientRect();
        const groupRect = group.getBoundingClientRect();
        const top = groupRect.top - asideRect.top + aside.scrollTop;
        const bottom = top + groupRect.height;

        // 下端が見えるところまで送る。見出しより長い分は、見出しの上端を優先する
        // 「検索」ボタンは下端に固定している（c-rail-listing.css）ので、その高さの分だけ手前で止める
        const max = aside.scrollHeight - aside.clientHeight;
        const button = aside.querySelector('.c-rail-listing__search');
        const reserve = button && getComputedStyle(button).position === 'sticky' ? button.offsetHeight + 32 : 0;
        let target = aside.scrollTop;
        if (bottom > target + aside.clientHeight - reserve) target = bottom - aside.clientHeight + reserve;
        if (target > max) target = max;
        if (top < target) target = top;
        if (Math.abs(target - aside.scrollTop) < 1) return;

        if (leaving) saved = target;
        aside.scrollTo({ top: target, behavior: 'smooth' });
      };

      aside.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-accordion-trigger]');
        const group = trigger?.closest('.c-rail-listing__group');
        if (!group || !aside.contains(group)) return;

        // 開く動き（高さのアニメーション）が終わってから測る。終わりの合図が来ない場合に備えて時間でも送る
        const panel = group.querySelector('[data-accordion-panel]');
        let done = false;
        const run = () => {
          if (done) return;
          done = true;
          reveal(group);
        };
        panel?.addEventListener('transitionend', run, { once: true });
        setTimeout(run, 450);
      });

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();
}
